@for (item of weekNumbers; track item) {
<div class="font-weight-bold ngb-dp-weekday small ng-star-inserted">
  {{ item.week }}
  @if (nonNullable(weeksPresetData[item.week + '-' + item.year])) {
  <atx-asterisk></atx-asterisk>
  }
</div>
}
